import React from 'react';

import cs from 'classnames';

import { ia } from 'lib/helpers/utility';
import { useUIContext } from 'lib/context/UIContext/UIContext';

import Modal from 'components/shared/Modal/Modal';
import Button from 'components/shared/Button/Button';
import Switch from 'components/shared/Switch/Switch';
import ErrorBoundary from 'components/shared/Error/Boundary';
import ErrorMessage from 'components/shared/ErrorMessage/ErrorMessage';

import WizardBreadcrumbs from './components/WizardBreadcrumbs';

const WizardModal = ({
  isOpen,
  handleClose,
  title,
  footerButtons,
  children,
  handleSaveProgress,
  handleAutoSave,
  autoSave,
  breadcrumbs,
  showAutoSave,
  showSaveProgress,
  saveProgressLoading,
  setBreadCrumbs,
  modalWidth,
  enableNavigation = false
}) => {
  const HeaderButtons = () => {
    return (
      <div className="ml-3 flex w-full items-center !justify-between">
        {device !== 'tablet-sm' && ia(breadcrumbs) && (
          <WizardBreadcrumbs
            breadcrumbs={breadcrumbs}
            setBreadCrumbs={setBreadCrumbs}
            enableNavigation={enableNavigation}
          />
        )}
        <div className={cs('!mr-4 flex gap-4', device === 'tablet-sm' && 'ml-auto')}>
          {showAutoSave && (
            <div className="flex items-center gap-[6px]">
              <Switch onChange={handleAutoSave} checked={!!autoSave} />
              <span className="w-max text-[14px] font-400">Auto-save</span>
            </div>
          )}
          {showSaveProgress && (
            <Button
              variant="secondary"
              icon="save-mono"
              isDisabled={saveProgressLoading}
              isLoading={saveProgressLoading}
              text={saveProgressLoading ? 'Saving' : 'Save Progress'}
              onClick={handleSaveProgress}
              size="small"
            />
          )}
        </div>
      </div>
    );
  };

  const { device } = useUIContext();
  return (
    <ErrorBoundary FallbackComponent={ErrorMessage}>
      <Modal
        isOpen={isOpen}
        handleClose={handleClose}
        title={title}
        headButton={<HeaderButtons />}
        footer={footerButtons}
        bodyClassName="!p-0 bg-primary-10"
        width={modalWidth}
        className={cs(
          '!bg-white',
          !modalWidth &&
            (device === 'tablet-sm'
              ? 'w-[729px]'
              : device === 'tablet'
                ? 'w-[984px]'
                : 'w-[1240px]')
        )}>
        {device === 'tablet-sm' && ia(breadcrumbs) && (
          <div className="bg-white p-4">
            <WizardBreadcrumbs
              breadcrumbs={breadcrumbs}
              setBreadCrumbs={setBreadCrumbs}
              enableNavigation={enableNavigation}
            />
          </div>
        )}
        {children}
      </Modal>
    </ErrorBoundary>
  );
};

export default WizardModal;
